import { computed } from 'vue'
import { useTokenRefreshV2 } from './useTokenRefreshV2'
import { useLogoutHandler } from './useLogoutHandler'
import { useSessionManager } from '@entities/auth'

export const useTokenManager = () => {
  const sessionManager = useSessionManager()
  const tokenRefreshV2 = useTokenRefreshV2()
  const logoutHandler = useLogoutHandler()

  const isLoggedIn = computed(() => {
    if (logoutHandler.isRefreshTokenInvalid()) return false
    return sessionManager.hasActiveSession.value
  })

  const refreshToken = (): Promise<string | null> => tokenRefreshV2.refreshToken()

  const ensureValidToken = (): Promise<boolean> => tokenRefreshV2.ensureValidToken()
  const getAccessToken = (): string | null => sessionManager.authAccessToken.value
  const getSessionId = (): string | null => sessionManager.authSessionId.value
  const getRefreshToken = (): string | null => sessionManager.authRefreshToken.value
  const isTokenExpired = (): boolean => sessionManager.isAccessTokenExpired()
  const shouldRefreshToken = (): boolean => sessionManager.shouldRefreshToken()

  return {
    isLoggedIn,
    hasActiveSession: sessionManager.hasActiveSession,
    accessToken: sessionManager.authAccessToken,
    refreshTokenValue: sessionManager.authRefreshToken,
    sessionId: sessionManager.authSessionId,
    refreshToken,
    ensureValidToken,
    getAccessToken,
    getRefreshToken,
    getSessionId,
    isTokenExpired,
    shouldRefreshToken,
  }
}
